// Add the filename slug (no .md) for each post you want on the blog.
// All metadata (title, date, tags, description) is read from the markdown file itself.
const posts = ['about-this-computer', 'hello-world']

export default posts
